import { get } from '@/libs/api.request'

export default {
  state: {
    common: {
      partExamCheckSolutions: []
    },
    stocks: {
    },
    erpUnits: [],
    partClasses: []
  },
  getters: {
    erpStocks: state => {
      return state.stocks
    }
  },
  mutations: {
    setPartExamCheckSolutions(state, data) {
      state.common.partExamCheckSolutions = data
    },
    setSotcks (state, stocks) {
      let merged = _.merge(state.stocks, stocks)
      state.stocks = Object.assign({}, merged)
    },
    setErpUnits(state, erpUnits) {
      state.erpUnits = erpUnits
    },
    setPartClasses(state, partClasses) {
      state.partClasses = partClasses
    }
  },
  actions: {
    getPartExamCheckSolutions({ commit }) {
      return get('erp/common/examine-check-solutions').then(resp => {
        commit('setPartExamCheckSolutions', resp.data)
        return resp.data
      })
    },
    getErpBomByPartNumber ({ commit }, part_number) {
      return get(`erp/boms/${part_number}`).then(res => {
        return res.data
      })
    },
    getErpBoms ({ commit }, data) {
      return get('erp/boms', data).then(res => {
        return res.data
      })
    },
    getErpUnits ({ commit }, data) {
      return get('erp/common/units', data).then(res => {
        commit('setErpUnits', res.data)
        return res.data
      })
    },
    getErpStocks({ commit, state }, { part_numbers }) {
      return get('erp/stocks', { part_numbers }).then(resp => {
        commit('setSotcks', resp.data)
        return resp.data
      })
    },
    getPartClassesTree ({ commit }, data) {
      return get('/erp/part-classes-tree', data).then(res => {
        commit('setPartClasses', res.data)
        return res.data
      })
    },
    getErpSuppliers ({ commit }, data) {
      return get('erp/suppliers', data).then(res => {
        return res.data
      })
    }
  }
}
